<template lang="pug">
    section#prouni
        .wrapper
            h2 Prouni
            p
                |A UniFAEL aderiu ao programa desde a sua criação e, há 14 anos,
                |concede bolsas de estudos Prouni para os inscritos que preencheram os requisitos definidos
                |pelo Ministério da Educação – MEC.  Os candidatos que não possuam diploma de curso superior e
                |que tenham participado do Enem (Exame Nacional do Ensino Médio), desde que tenham obtido no
                |mínimo 450 pontos na média das notas do Exame e nota acima de zero na redação, podem se inscrever no
                |processo seletivo do Prouni e concorrer a uma das bolsas de estudo do Programa.
            a(href="/prouni").saibamais Saiba mais
</template>

<script>
export default {
    name: "section-prouni"
}
</script>

<style lang="stylus" scoped src="./Prouni.styl"></style>
